/** @format */

import React from "react"
import { Container, NoSearchResultIcon } from "./NoSearchResultMember.styled"
import { NoSearchResultMemberProps } from "./NoSearchResultMember.types"

export const NoSearchResultMember = (props : NoSearchResultMemberProps) => {
	
	return (
		<Container data-testid="no-results-member">
			<NoSearchResultIcon/>
			<h2>{`Aucun membre ${props.hasSearchCriteria ? "correspondant aux critères de recherche" : ""} n'a été trouvé`}</h2>
		</Container>	
	)
}
